import React from 'react'
import { Button, Grid, Typography, useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/styles'
import { useFormikContext } from 'formik'
import api from '../../../utils/api'
import MoMo_Logo from '../../../assets/MoMo_Logo.png'

const ChoosePaymentMethod = (props) => {
  const theme = useTheme()
  const matchesMD = useMediaQuery(theme.breakpoints.up('md'))

  const { values } = useFormikContext()

  const handleSubmitMoMoPay = async () => {
    const res = await api.post('/momo-payment/create-payment-url', values)
    window.location.replace(res.data.payUrl)
  }

  return (
    <Grid item container direction="column" alignItems="center" spacing={2}>
      <Grid item>
        <Typography
          variant={matchesMD ? 'h4' : 'h5'}
          style={{
            textTransform: 'uppercase',
            fontWeight: '600',
            textAlign: 'center',
          }}
        >
          Chọn phương thức thanh toán
        </Typography>
      </Grid>

      <Grid item style={{ textAlign: 'center' }}>
        <img src={MoMo_Logo} alt='MoMoPay-logo' style={{ width: '60%' }} />
      </Grid>

      <Grid item>
        <Button variant='contained' color='primary' size='large' onClick={handleSubmitMoMoPay} style={{ color: 'white' }}>Chọn MoMo</Button>
      </Grid>

      <Grid item>
        <Typography variant='body1'>* Hiện nay chúng tôi chỉ hổ trợ thanh toán qua MoMo.</Typography>
      </Grid>
    </Grid>
  )
}

export default ChoosePaymentMethod
